import Api from './Api';

class _VideoApi extends Api {
    requestVideo({ character_id, script, instructions, notify }: any): Promise<any> {
        return this.getHttpClient().post(`/video/request`, { character_id, script, instructions, notify });
    }

    loadVideoList(data: any): Promise<any> {
        return this.getHttpClient().post(`/video/list`, data);
    }

    storeVideoRequestVideo(data: any): Promise<any> {
        return this.getHttpClient(false).post(`/video/store`, data);
    }

    removeVideoRequestVideo(video: any): Promise<any> {
        return this.getHttpClient().delete(`/video/${video.id}`);
    }

    loadVideoRequestDetail(idOrHash: number | string, params: any = {}): Promise<any> {
        return this.getHttpClient(false).get(`/video/request/${idOrHash}`, { params });
    }

    loadVideoRequestDetailByCharacter(character: number, params: any = {}): Promise<any> {
        return this.getHttpClient().get(`/video/request/character/${character}`, { params });
    }

    loadVideo(hash: string): Promise<any> {
        return this.getHttpClient().get(`/video/${hash}`);
    }
}

export const VideoApi = new _VideoApi();
